import { message } from "antd";
import { push } from "connected-react-router";
import { get } from "lodash";
import { sessionActions } from "../actions";
import { authProvider } from "./providers";

import { DEFAULT_SMS_VERIFY_CODE, STORAGE_KEYS } from "shared/constant";
import { LOGIN, LOGOUT, ME, SEND_SMS, UPDATE_PASSWORD, VERIFY_SMS } from "./providers/requestType";

export const logIn = (loginDetails) => async (dispatch) => {
  const { account, password } = loginDetails;

  const response = await authProvider(LOGIN, {
    body: { account, password },
    json: true
  });
  const token = get(response, "data.token");
  // 錯誤處理
  const errorCode = get(response, "message.error.code");
  const defaultErrorMessage = "發生未知錯誤，請稍後再試";
  const errorMessages = {
    10001: "密碼錯誤 or 使用者不存在",
    10003: "輸入密碼錯誤超過5次，請於15分鐘後重試"
  };

  if (token) {
    localStorage.setItem(STORAGE_KEYS.TOKEN, token);
    return dispatch({ type: sessionActions.LOGIN, ...response });
  }

  if (errorCode) {
    message.error(errorMessages[errorCode] || defaultErrorMessage);
  }
  return response;
};

export const logOut = () => async (dispatch) => {
  const response = await authProvider(LOGOUT);
  if (response.data.status === 1) {
    localStorage.removeItem(STORAGE_KEYS.TOKEN);
    localStorage.removeItem(STORAGE_KEYS.OPEN_MODAL);
    dispatch(push("/login"));
  }
};

export const roughLogOut = () => {
  localStorage.removeItem(STORAGE_KEYS.TOKEN);
  localStorage.removeItem(STORAGE_KEYS.OPEN_MODAL);
  window.location.href = "/login";
};

export const sendSmsVerifyCode = async (params) => {
  const resp = await authProvider(SEND_SMS, {
    body: {
      ...params,
      options: DEFAULT_SMS_VERIFY_CODE
    }
  });
  if (resp && resp.data) return resp.data;
  if (resp && resp.err) return resp.err;
};

export const verifyPhone = async (params) => {
  const resp = await authProvider(VERIFY_SMS, { body: params });
  if (resp && resp.data) return resp.data;
  if (resp && resp.err) return resp.err;
};

export const getUser = () => async (dispatch) => {
  const res = await authProvider(ME);

  if (res && res.data) return dispatch({ type: sessionActions.ME, data: res.data });
  if (res && res.err) return res;
};

export const updatePassword = async (params) => {
  const res = await authProvider(UPDATE_PASSWORD, params);
  if (res && res.data) return res.data;

  if (res && res.err) return res;
};
